import { render, staticRenderFns } from "./ReservationCancel.vue?vue&type=template&id=04bca399&scoped=true&"
import script from "./ReservationCancel.vue?vue&type=script&lang=js&"
export * from "./ReservationCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bca399",
  null
  
)

export default component.exports